/* eslint-disable */
import Long from "long";
import _m0 from "protobufjs/minimal";
import { HistoryAlbumUser } from "./HistoryAlbumUser";

export const protobufPackage = "Reality.Reality.Api";

export interface HistoryAlbumUserGiftCount {
  user: HistoryAlbumUser | undefined;
  count: number;
}

function createBaseHistoryAlbumUserGiftCount(): HistoryAlbumUserGiftCount {
  return { user: undefined, count: 0 };
}

export const HistoryAlbumUserGiftCount = {
  encode(message: HistoryAlbumUserGiftCount, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.user !== undefined) {
      HistoryAlbumUser.encode(message.user, writer.uint32(10).fork()).ldelim();
    }
    if (message.count !== 0) {
      writer.uint32(16).int64(message.count);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): HistoryAlbumUserGiftCount {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseHistoryAlbumUserGiftCount();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.user = HistoryAlbumUser.decode(reader, reader.uint32());
          continue;
        case 2:
          if (tag !== 16) {
            break;
          }

          message.count = longToNumber(reader.int64() as Long);
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): HistoryAlbumUserGiftCount {
    return {
      user: isSet(object.user) ? HistoryAlbumUser.fromJSON(object.user) : undefined,
      count: isSet(object.count) ? globalThis.Number(object.count) : 0,
    };
  },

  toJSON(message: HistoryAlbumUserGiftCount): unknown {
    const obj: any = {};
    if (message.user !== undefined) {
      obj.user = HistoryAlbumUser.toJSON(message.user);
    }
    if (message.count !== 0) {
      obj.count = Math.round(message.count);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<HistoryAlbumUserGiftCount>, I>>(base?: I): HistoryAlbumUserGiftCount {
    return HistoryAlbumUserGiftCount.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<HistoryAlbumUserGiftCount>, I>>(object: I): HistoryAlbumUserGiftCount {
    const message = createBaseHistoryAlbumUserGiftCount();
    message.user = (object.user !== undefined && object.user !== null)
      ? HistoryAlbumUser.fromPartial(object.user)
      : undefined;
    message.count = object.count ?? 0;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function longToNumber(long: Long): number {
  if (long.gt(globalThis.Number.MAX_SAFE_INTEGER)) {
    throw new globalThis.Error("Value is larger than Number.MAX_SAFE_INTEGER");
  }
  return long.toNumber();
}

if (_m0.util.Long !== Long) {
  _m0.util.Long = Long as any;
  _m0.configure();
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
